import { createCustomInterceptorInstance } from "@fundacao/shared-components/esm/ie/renovacao";
import axios, { AxiosInstance } from "axios";
import { Bolsa } from "../../models/bolsa";

class BolsasService{
  private instance: AxiosInstance;

  constructor() {
    this.instance = createCustomInterceptorInstance(process.env.REACT_APP_USER_SESSION_API);
  }

  async getUsuarioIesBolsas(): Promise<Bolsa[]>{
      const resp  = await this.instance
        .get(`/bolsas/usuario-ies`)
        .catch(err => Promise.reject(err.response));
      return resp.data.bolsas;
  }

}

export default new BolsasService();